import { createEffect, createEvent, createStore, sample } from 'effector';
import { buildingCorpsApi, BuildingCorpsInDB } from '../api/buildingCorps';
import { $canDeleteComplex as $canManageCorps } from './auth';

// Загрузка по зданию
export const fetchCorpsByBuildingFx = createEffect(async (buildingId: string) => {
  const list = await buildingCorpsApi.getByBuilding(buildingId);
  return { buildingId, list };
});

// Создание корпуса
export const createCorpsFx = createEffect(async (params: { buildingId: string; name: string }) => {
  const created = await buildingCorpsApi.create({
    building_id: params.buildingId,
    name: params.name,
  });
  return { buildingId: params.buildingId, corps: created };
});

// Удаление корпуса
export const deleteCorpsFx = createEffect(async ({ id, force = false }: { id: string; force?: boolean }) => {
  await buildingCorpsApi.delete(id, force);
  return id;
});

// Событие клика «Удалить» из UI
export const deleteCorpsClicked = createEvent<{ corpsId: string; buildingId?: string; force?: boolean }>();

// Разрешаем удаление только при правах супер/админ
sample({
  clock: deleteCorpsClicked,
  filter: $canManageCorps,
  fn: ({ corpsId, force }) => ({ id: corpsId, force }),
  target: deleteCorpsFx,
});

// Список корпусов по buildingId
export const $corpsByBuilding = createStore<Record<string, BuildingCorpsInDB[]>>({})
  .on(fetchCorpsByBuildingFx.doneData, (state, { buildingId, list }) => ({
    ...state,
    [String(buildingId)]: list,
  }))
  .on(createCorpsFx.doneData, (state, { buildingId, corps }) => {
    const key = String(buildingId);
    const prev = state[key] || [];
    return { ...state, [key]: [corps, ...prev] };
  })
  .on(deleteCorpsFx.doneData, (state, removedId) => {
    const next: Record<string, BuildingCorpsInDB[]> = {};
    for (const key of Object.keys(state)) {
      next[key] = (state[key] || []).filter((c) => String(c.id) !== String(removedId));
    }
    return next;
  });

// Трекинг удаления для спиннеров
export const $deletingCorpsIds = createStore<Set<string>>(new Set())
  .on(deleteCorpsFx, (s, payload) => new Set(s).add(String(payload.id)))
  .on(deleteCorpsFx.finally, (s, { params }) => {
    const next = new Set(s);
    next.delete(String(params.id));
    return next;
  });
